/* eslint-disable camelcase */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { toast } from 'react-toastify';
import { withTranslation } from 'react-i18next';

// Styles
import {
  Container,
  InputContainer,
  StyledInputV2,
  StyledLabel,
  ButtonContainer,
} from '../CreateEvent/style';
import { FormHeading } from '../ChallengeCreationAdmin/ActivityChallengeLaunch/style';
import { Main } from '../AdminTeamCreation/styles';
import { Layout } from '../EditWellnessJourney/styles';
import { Border } from '../Journeys/styles';
import { ManagerIconContainer } from '../Manager/styles';
import { CommonButtonPopup } from '../ReportsV2/styles';

// Utils & Constants
import { fetchApi } from '../../utils/methods';
import { AddQuizAPI } from '../../redux/constants/apiConstants';
import { DeleteChallengeIcon, NewPlusIcon, RecognitionCloseIcon } from '../../utils/icons';

// Mocking StepsHeading
import StepsHeading from '../../components/RecogntionAdmin/corevalues/stepNames';
import { AddOption, /*AddQuestion, OptionInput,*/ OptionLabel, OptionRow, Question, QuizCard, RemoveIcon, /*RemoveQuestion*/ } from './styles';
import { withRouter } from "react-router-dom";



class CreateArticleQuizForm extends Component {
  constructor(props) {
    super(props);


    this.state = {
      title:null,
      step: 1,
      isDisabled:false,
      quizzes: [
        {
          quiz: "",
          options: [
            { label: "A", value: "", is_correct: false },
            { label: "B", value: "", is_correct: false },
          ],
        },
      ],
    };
  }



  /* ---------------- QUESTIONS ---------------- */

  handleQuestionChange = (qIndex, value) => {
    const quizzes = [...this.state.quizzes];
    quizzes[qIndex].quiz = value;
    this.setState({ quizzes });
  };

  addQuestion = () => {
    this.setState({
      quizzes: [
        ...this.state.quizzes,
        {
          quiz: "",
          options: [
            { label: "A", value: "", is_correct: false },
            { label: "B", value: "", is_correct: false },
          ],
        },
      ],
    });
  };

  removeQuestion = (qIndex) => {
    const quizzes = [...this.state.quizzes];
    quizzes.splice(qIndex, 1);
    this.setState({ quizzes });
  };
  
  /* ---------------- OPTIONS ---------------- */

  handleOptionChange = (qIndex, oIndex, value) => {
    const quizzes = [...this.state.quizzes];
    quizzes[qIndex].options[oIndex].value = value;
    this.setState({ quizzes });
  };

  selectCorrectOption = (qIndex, oIndex) => {
    const quizzes = [...this.state.quizzes];
  
    quizzes[qIndex].options[oIndex].is_correct =
      !quizzes[qIndex].options[oIndex].is_correct;
  
    this.setState({ quizzes });
  };
  
  
  addOption = (qIndex) => {
    const quizzes = [...this.state.quizzes];
    const options = quizzes[qIndex].options;

    if (options.length >= 4) return;

    options.push({
      label: String.fromCharCode(65 + options.length),
      value: "",
      is_correct: false,
    });

    this.setState({ quizzes });
  };
  
  removeOption = (qIndex, oIndex) => {
    const quizzes = [...this.state.quizzes];
    let options = quizzes[qIndex].options;

    if (options.length <= 2) return;

    options.splice(oIndex, 1);

    options = options.map((opt, i) => ({
      ...opt,
      label: String.fromCharCode(65 + i),
    }));

    quizzes[qIndex].options = options;
    this.setState({ quizzes });
  };


  // --- Event Handlers ---

  onChangeInput = (e) => {
    this.setState({ [e.target.name]: e.target.value });

    if (e.target.name === 'description') {
      this.setState({ charCount: e.target.value.length });
    }
  };

  onChangeImage = (baseImage, imageName) => {
    this.setState({
      image: baseImage,
      imageName: imageName,
      imageUpdated: true,
    });
  };

  onChangeAudio = (e) => {
    const file = e.target.files[0];
    if (file) {
      if ((file.size / 1000000) <= 10) {
        if (file.type === 'audio/mpeg' || file.name.endsWith('.mp3')) {
          const reader = new FileReader();
          reader.readAsDataURL(file);
          reader.onloadend = () => {
            this.setState({
              audio: reader.result,
              audioName: file.name,
            });
          };
        } else {
          toast.error(this.props.t('Please upload an .mp3 file'));
        }
      } else {
        toast.error(this.props.t('Maximum file size 10 MB'));
      }
    }
  };

  removePhoto = () => {
    this.setState({ image: '', imageName: '' });
  };

  removeAudio = (e) => {
    e.preventDefault();
    this.setState({ audio: '', audioName: '' });
  };

  onChangeArticleContent = (evt) => {
    const newContent = evt.getData();
    this.setState({ description: newContent });
  };

  // Multiple Selection Logic
  onSelectCategory = (item) => {

    this.setState({ journey_category_ids: item.id });
  };


  onSelectTheme = (item) => {
    this.setState({selectedWellbeingPillar:item});
  };

  onSelectLevel = (item) => {
    this.setState({ level: item, levelOpen: false });
  };

  onSelectGoal = (item) => {
    // When wellness goal is selected, fetch related questions
    this.setState({ 
      wellness_goal: item, 
      goalOpen: false,
      question: null, // Reset question when goal changes
    }, () => {
      // Fetch questions for this wellness goal
      this.getWBAQuestions(item.id);
    });
  };

  // Question selection handler
  onSelectQuestion = (item) => {
    this.setState({ 
      question: item, 
      questionOpen: false 
    });
  };

  // --- Navigation & Validation ---

  nextStep = () => {
    if (this.isStepValid()) {
      this.setState((prev) => ({ step: prev.step + 1 }));
      window.scrollTo(0, 0);
    } else {
      toast.error(this.props.t('Please fill all mandatory fields'));
    }
  };

  prevStep = () => {
    this.setState((prev) => ({ step: prev.step - 1 }));
    window.scrollTo(0, 0);
  };

  isStepValid = () => {
    const {
      step, title, imageName, journey_category_ids, description
    } = this.state;

    if (step === 1) {
      return title && title.trim() !== '' && imageName;
    }
    if (step === 2) {
      // Validate that the array has at least one item
      return journey_category_ids;
    }
    if (step === 3) {
      // "Type Article" is mandatory. Audio is optional.
      return description && description.trim() !== '';
    }
    return true;
  };

  redirect = () => {
    this.props.history.goBack();
  };

  renderHeading = () => (
    <FormHeading color="#184A61">
      <div className="close-icon" onClick={this.redirect}>
        <ManagerIconContainer isWidth="32px">{RecognitionCloseIcon('#F37A65')}</ManagerIconContainer>
      </div>
      {this.props.t('Create Quiz')}
    </FormHeading>
  );

  // --- Step 1: About Article ---
  renderStepOne = () => {
    const { t } = this.props;
    const {
      quizzes
    } = this.state;


    return (
      <div className="formBody">


        {/* <Border style={{ background: '#EFEFEF', margin: '20px 0 8px 0px' }} /> */}

        {quizzes.map((quiz, qIndex) => (
          <QuizCard key={qIndex}>
            {/* Question */}
            {/* <QuestionInput
              type="text"
              placeholder={`Question ${qIndex + 1}`}
              value={quiz.quiz}
              onChange={(e) =>
                this.handleQuestionChange(qIndex, e.target.value)
              }
            /> */}

            <InputContainer>
              <Question>
                <div className='text'>{t(`Question ${qIndex + 1}`)}</div>
                {quizzes.length > 1 && (<div onClick={() => this.removeQuestion(qIndex)}>{<DeleteChallengeIcon/>}</div>)}
              </Question>
              

              <StyledLabel isFont="16px" color="#184A61" margin="12px" marginb="12px" symbolSize="16px">
                {t(`What would you like to ask?`)}
              </StyledLabel>
              <StyledInputV2
                placeholder={t('Enter question')}
                name="title"
                onChange={(e) =>
                  this.handleQuestionChange(qIndex, e.target.value)
                }
                value={quiz.quiz}
                maxLength="100"
                bgColor="white"
                style={{ background: 'white' }}
                pColor="#BDBDBD"
                color="#184A61"
                border="1px solid #BDBDBD"
              />
              <div className="count" style={{height:'auto'}}>
                {quiz?.quiz?.length}
                /100 | C
              </div>
            </InputContainer>
            <Border style={{ background: '#EFEFEF', margin: '8px 0px' }} />
        
            {/* Options */}
            <StyledLabel isFont="16px" color="#184A61" margin="12px" marginb="12px" symbolSize="16px" style={{float:'unset'}}>
              {t(`Options`)}
              <span>*</span>
            </StyledLabel>
            {quiz.options.map((opt, oIndex) => (
              <OptionRow key={opt.label}>
                {/* A/B/C/D */}
                <OptionLabel
                  active={opt.is_correct}
                  onClick={() =>
                    this.selectCorrectOption(qIndex, oIndex)
                  }
                >
                  {opt.label}
                </OptionLabel>
        
                {/* Option input */}
                {/* <OptionInput
                  type="text"
                  placeholder={`Option ${opt.label}`}
                  value={opt.value}
                  onChange={(e) =>
                    this.handleOptionChange(
                      qIndex,
                      oIndex,
                      e.target.value
                    )
                  }
                /> */}

                <StyledInputV2
                  placeholder={`Option ${opt.label}`}
                  name="title"
                  onChange={(e) =>
                    this.handleOptionChange(
                      qIndex,
                      oIndex,
                      e.target.value
                    )
                  }
                  value={opt.value}
                  maxLength="100"
                  bgColor="white"
                  style={{ background: 'white' }}
                  pColor="#BDBDBD"
                  color="#184A61"
                  border="1px solid #BDBDBD"
                />
        
                {/* Remove option */}
                {quiz.options.length > 2 && (
                  <RemoveIcon
                    onClick={() =>
                      this.removeOption(qIndex, oIndex)
                    }
                  >
                    −
                  </RemoveIcon>
                )}
              </OptionRow>
            ))}
        
            {/* Add option */}
            {quiz.options.length < 4 && (
              <AddOption onClick={() => this.addOption(qIndex)}>
                <span className='icon'><NewPlusIcon fill={'#DA6C74'}/></span> <span className='text'>Add options</span>
              </AddOption>
            )}
        
          </QuizCard>
        ))}
        
        {/* Add question */}
        <Border style={{ background: '#EFEFEF', margin: '8px 0px' }} />
        <AddOption onClick={this.addQuestion}>
          <span className='filled-icon'><NewPlusIcon fill={'#DA6C74'}/></span> <span className='text'>Add question</span>
        </AddOption>

      </div>
    );
  };



  onSubmit = (e) => {
    e.preventDefault();
    const { quizzes } = this.state;
    const journey_id = this.props.match?.params?.id; // or from props / route params
  
    const payload = {
      journey_id,
      quizzes: quizzes.map((q) => ({
        quiz: q.quiz,
        choices: q.options.map((opt) => ({
          choice: opt.value,
          is_correct: opt.is_correct ? 1 : 0
        }))
      }))
    };
  
    window.console.log("SUBMIT PAYLOAD 👉", payload);
    this.createArticleQuiz(payload)
  
    // API call
    // api.post("/quiz", payload)


  };

  createArticleQuiz = async (payload) => {
    this.setState({ isDisabled: true }); 
    try {
      const res = await fetchApi(AddQuizAPI , "POST",payload);
      if (res.status === "success") {
        this.props.history.push(`/wellness-resources/article-details/${this.props.match?.params?.id}`);
      } else {
        toast.error(res.data.message || "Something went wrong");
      }
    } catch (error) {
      window.console.error(error);
    }finally{
      this.setState({ isDisabled: false }); 
    }
  };

  isQuizValid = () => {
    const { quizzes } = this.state;
  
    // At least one question
    if (!quizzes || quizzes.length === 0) {
      return false;
    }
  
    for (let i = 0; i < quizzes.length; i++) {
      const quiz = quizzes[i];
  
      // Question text required
      if (!quiz.quiz || quiz.quiz.trim() === "") {
        return false;
      }
  
      // Minimum 2 options
      if (!quiz.options || quiz.options.length < 2) {
        return false;
      }
  
      // Option text required
      for (let j = 0; j < quiz.options.length; j++) {
        if (!quiz.options[j].value || quiz.options[j].value.trim() === "") {
          return false;
        }
      }
  
      // At least one correct option
      const hasCorrect = quiz.options.some((opt) => opt.is_correct);
      if (!hasCorrect) {
        return false;
      }
    }
  
    return true;
  };

  showQuizValidationError = () => {
    const { quizzes } = this.state;
  
    for (let i = 0; i < quizzes.length; i++) {
      const quiz = quizzes[i];
  
      if (!quiz.quiz || quiz.quiz.trim() === "") {
        toast.error(`Question ${i + 1} cannot be empty`);
        return;
      }
  
      if (quiz.options.length < 2) {
        toast.error(`Question ${i + 1} must have at least 2 options`);
        return;
      }
  
      for (let j = 0; j < quiz.options.length; j++) {
        if (!quiz.options[j].value || quiz.options[j].value.trim() === "") {
          toast.error(`Option ${quiz.options[j].label} in Question ${i + 1} is empty`);
          return;
        }
      }
  
      const hasCorrect = quiz.options.some((opt) => opt.is_correct);
      if (!hasCorrect) {
        toast.error(`Select at least one correct option for Question ${i + 1}`);
        return;
      }
    }
  };
  
  

  render() {
    const { step,isDisabled } = this.state;
    const { t } = this.props;
    const isQuizValid = this.isQuizValid();


    return (
      <Layout>
        <div className="main">
          {this.renderHeading()}
          <Container height="100%" stepBackground="#005C87" color="#005C87" paddingForm>

            <div className="stepsNameHighlight">
              <StepsHeading stepCount={step} type="article-quiz" padding="20px 20px 265px 20px" />
            </div>

            <div className="form" >
              <form onSubmit={(e) => { 
                e.preventDefault(); 
                this.setState({ isDisabled: true }); 
                // this.onSubmit(e, this.state); 
              }}>
                {step === 1 && this.renderStepOne()}
              </form>
            </div>
          </Container>

          <ButtonContainer style={{width:'100%', left:'0'}}>
            <Main>
              <div className="wrapper" style={{ display: 'flex', width: '100%', justifyContent: 'flex-end' }}>
                <CommonButtonPopup
                  height="48px"
                  width="200px"
                  margin={step === 1 ? 'auto 0 auto auto' : 'auto 0 auto auto'}
                  disabled={!isQuizValid || isDisabled}
                  onClick={(event) => {
                    if (!isQuizValid) {
                      this.showQuizValidationError();
                      return;
                    }
                 
                    // proceed with submit
                    this.onSubmit(event);
                  }}
                  style={{
                    backgroundColor: isQuizValid ? '#DA6C74' : '#EFEFEF',
                    color: isQuizValid ? '#FFFFFF' : '#666666',
                    cursor: isQuizValid ? 'pointer' : 'not-allowed',
                  }}
                >
                  {t('Create')}
                </CommonButtonPopup>
              </div>
            </Main>
          </ButtonContainer>
        </div>
      </Layout>
    );
  }
}

CreateArticleQuizForm.propTypes = {
  state: PropTypes.object.isRequired,
  buttonText: PropTypes.string.isRequired,
  validationConfig: PropTypes.object,
  onSubmit: PropTypes.func.isRequired,
  journey_category_id: PropTypes.array,
  t: PropTypes.func,
  history: PropTypes.object,
  match:PropTypes.object
};


export default withRouter(withTranslation()(CreateArticleQuizForm));